import React, {useState} from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { userId } from "../modules/auth";
import EmailVerification from "../Components/Layout/EmailVerification";
import { ButtonPrimary } from "../Components/Button";
import axios from 'axios'
function NotFound({ children, userId, user, token }) {
  const location = useLocation();
  const [banner, setBanner] = useState("show");
  const sendNewVerificationEmail = () => {
    setBanner("loading");
    axios
      .post(`${window.API}/users/me/new-verification`, null, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(data => {
        setBanner("complete");
      })
      .catch(data => {
        setBanner("error");
      });
  };
  return (
    <div className="py-8 container">
      <h1 className="text-3xl mb-5 mt-5">Email Verification Required</h1>
      <p>Sorry the page you are looking for requires email verification. Please check your email for the verification link.</p>
      {banner === "show" ?
        <ButtonPrimary onClick={sendNewVerificationEmail}>
          Send new verification email
        </ButtonPrimary>
        :
        <div className="flex items-center gap-2 text-green font-semibold">
          <i className="fas fa-check-circle" />
          <span>Verfication Email Sent</span>
        </div>
      }

    </div>
  );
}

export default connect(state => ({
  userId: userId(state),
  user: state.auth.user,
  token: state.auth.token,
}))(NotFound);
